var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDeleteBin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.207c0-.571.448-1.034 1-1.034h18c.552 0 1 .463 1 1.034 0 .572-.448 1.035-1 1.035H1c-.552 0-1-.463-1-1.035z",
    fill: "#ED1B2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2.104a.983.983 0 00-.707.303A1.053 1.053 0 007 3.138v1.035h6V3.138c0-.274-.105-.537-.293-.731A.983.983 0 0012 2.104H8zm7 2.069V3.138c0-.823-.316-1.612-.879-2.194A2.95 2.95 0 0012 .034H8a2.95 2.95 0 00-2.121.91A3.159 3.159 0 005 3.138v1.035H3c-.552 0-1 .463-1 1.034v14.484c0 .823.316 1.612.879 2.194a2.95 2.95 0 002.121.91h10a2.95 2.95 0 002.121-.91A3.16 3.16 0 0018 19.691V5.207c0-.571-.448-1.034-1-1.034h-2zM4 6.242V19.69c0 .274.105.537.293.731a.983.983 0 00.707.303h10c.265 0 .52-.109.707-.303.188-.194.293-.457.293-.731V6.24H4z",
    fill: "#ED1B2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 9.345c.552 0 1 .464 1 1.035v6.207c0 .571-.448 1.035-1 1.035s-1-.464-1-1.035V10.38c0-.571.448-1.035 1-1.035zM12 9.345c.552 0 1 .464 1 1.035v6.207c0 .571-.448 1.035-1 1.035s-1-.464-1-1.035V10.38c0-.571.448-1.035 1-1.035z",
    fill: "#ED1B2E"
  })));
}

export default SvgDeleteBin;